import React from "react";
import PropTypes from "prop-types";
import { Group } from "./GroupConversation/index.jsx";
import { getGeneralConversationName } from "../../util.jsx";

export const GeneralConversation = ({ conversationId }) => {
  const name = getGeneralConversationName();
  return (
    <Group
      name={name}
      conversationId={conversationId}
    />
  );
};

GeneralConversation.propTypes = {
  conversationId: PropTypes.number.isRequired,
};
